export { DeteriorationModelResultsTab } from './DeteriorationModelResultsTab';
